import Plans from "../../../pages/fanclub/plan/Plans";
import CreateFanclubPlan from "../../../pages/fanclub/plan/Create";
import PlanEdit from "../../../pages/fanclub/plan/PlanEdit";
import {getFanclubPlanCreateRoute, getFanclubPlanEditRoute, getFanclubPlansRoute} from "./factory/plan";

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getFanclubPlansRoute(),
        component: Plans,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getFanclubPlanCreateRoute(),
        component: CreateFanclubPlan,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getFanclubPlanEditRoute(),
        component: PlanEdit,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;